import React from 'react'
import Link from 'next/link'
import { Row, Button, Tooltip } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { EditOutlined } from '@ant-design/icons'
import styles from './CustomPanelItem.module.scss'
import { FormLabels, CustomCol } from 'src/components'

interface CustomPanelItemProps {
  title: string
  subtitle: string
  link: string
}

const CustomPanelItem: React.FC<CustomPanelItemProps> = (props) => {
  const { t } = useTranslation()
  const { title, subtitle, link } = props
  const { isMobile } = useWindowSize()

  return <Link href={link} passHref legacyBehavior>
    <a>
      <Row className={styles.row}>
        <CustomCol xs={20} lg={23}>
          <FormLabels
            title={title}
            subtitle={subtitle}
          />
        </CustomCol>
        <CustomCol xs={4} lg={1}>
          <Tooltip
            color='blue'
            title={t('settings.editFields')}
            className={isMobile ? 'mt-2 ml-3' : 'mt-3'}
          >
            <Button type='text' icon={<EditOutlined style={{ fontSize: '130%' }} />} />
          </Tooltip>
        </CustomCol>
      </Row>
    </a>
  </Link>
}

export default CustomPanelItem
